export class SearchAccountMovementsRequest {
  nroCuenta: string;
  anio: number;
  mes: number;
  page: number;
  size: number;

  constructor(data: {
    nroCuenta: string;
    anio?: number;
    mes?: number;
    page?: number;
    size?: number;
  }) {
    this.nroCuenta = data.nroCuenta;
    this.anio = data.anio || new Date().getFullYear();
    this.mes = data.mes || new Date().getMonth();
    this.page = data.page;
    this.size = data.size;
  }
}